import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedModule } from '../../SharedModule';
import { SecurityService } from '../../../services/security';
import { environment } from '../../../../environments/environment';
import * as crypto from "crypto-js";

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    SharedModule
  ],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  name !: string
  user !: string
  showDropOnClick: boolean = false;
  constructor(
    private __router: Router,
    private __securityService: SecurityService
  ) {
  }

  ngOnInit(): void {
    if (sessionStorage.getItem('profile') == undefined) {
      this.getInfoUser();
    } else {
      this.name = localStorage.getItem('name')!;
      this.user = localStorage.getItem('user')!;
    }
  }

  getInfoUser(){
    let usEnc = ''+localStorage.getItem('user');
    let param = {
      "password": '',
      "mail": usEnc,
      "loginType": 1
    }

    this.__securityService.authentication(param).subscribe( (data: any) => {
      if(data.an_resultado == 1){
        this.user = data.res_obj_login.mail;
        this.name = data.res_obj_login.name;
      }
    });

  }

  logoutUser(){
    if (sessionStorage.getItem('profile') !== 'undefined') {
      localStorage.clear();
      sessionStorage.clear();
      this.__router.navigate(['/login']).then(() => {
        window.location.reload();
      });
    } else {
      localStorage.clear();
      sessionStorage.clear();
      this.__router.navigate(['/non-authorized']);
    }
  }

}
